import { TestId } from "../testIdType"

export const testId: TestId = {
    addAgent: "add-agent",
    deleteAgent: "delete-agent",
    saveAgent: "save-agent"
}
